import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'

export default {
	name: 'reprint-bins',
	components: {
		BasicSelect,
		VueElementLoading,
		Paginate
	},
	props: [],
	data() {
		return {
			binno:'',
			hubid:'',
			isLoadingSearch:false,
			binDetails:[],
      prnData:'',
      createdby:'',
			pageCount: 0,
			totalRows: 0,
      limit: 10,
			offset:0
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.hubid = userdetail[0].HubId[0];
		this.createdby = userdetail[0].email;
	},
	methods: {
		getBinDetails: function() {
			this.$validator.validateAll().then((result) => {
				if (!result) { return false; } else { this.getReprintBin(); }
			}).catch(() => {
				console.log('errors exist');
			});
		},

		getReprintBin(){
			this.binDetails=[]; this.isLoadingSearch = true;
			this.input = ({
			  currentHubId: this.hubid,
			  binNumber: this.binno ? this.binno : null,
				limit:this.limit,
				offset:this.offset
			});

			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'getReprintBin',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(async result => {
					this.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.binDetails = result.data.ResponseData[0];

						this.totalRows=result.data.TotalCount
            if (this.totalRows < 10) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(this.totalRows / 10);
            }
						this.$alertify.success(result.data.ReturnMessage);
					} else {
						this.totalRows=0; this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					this.isLoadingSearch = false; console.error(error);
				})
		},

		getPaginationData(pageNum) {
      this.offset = (pageNum - 1)
      this.getReprintBin()
    },

		resetForm(){
		 this.binno = ''; this.binDetails = []; this.totalRows = 0;
		 this.$validator.reset();
	 },

	 preparePrint(data){
		 if(data){
			let str = ''; this.isLoadingSearch = true;
			str = str.concat(`^XA
				^SZ2^JMA
				^MCY^PMN
				^PW812
				~JSN
				~SD25^MD0
				^JZY
				^LH0,0^LRN
				^XZ
				^XA
				^FO7,570
				^GB801,0,3^FS
				^FO8,40
				^GB795,0,3^FS
				^FT225,461
				^CI0
				^A0B,102,105^FD${data.groupcode}^FS
				^FT394,472
				^A0B,102,138^FD${((!isNaN(data.binno.charAt(0))) ? data.binno : '')}^FS
				^FO482,112
				^BY4^BCB,102,N,N^FD>:${data.ptlid}^FS
				^FT635,393
				^A0B,56,76^FD${data.ptlid}^FS
				^PQ1,0,1,Y
				^XZ`);
			this.prnData = str;

			this.isLoadingSearch = false;
			if(this.prnData){ this.printerSticker(this.prnData); }
		 }else{
			 this.$alertify.error('Error: Please check data not found for print action.');
		 }
	 },

	 printerSticker(prnData) {

		 this.input = {
			 prnData: prnData,
			 bagNumber: moment().format('DD-MM-YYYY')
		 }
		 this.isLoadingSearch = true;
		 axios({
				 method: "POST",
				 url: "http://localhost:4500/printer/printbagsticker",
				 data: this.input,
			 })
			 .then(result => {
				 console.log(result);
				 if (result.data.ResultCode == 100) {
					 this.$alertify.success(result.data.ReturnMessage);
					 this.$validator.reset();
					 this.errors.clear();
				 } else {
					 this.$alertify.error(result.data.ReturnMessage);
				 }
			 }, error => {
				 var code = error.response == undefined ? code = 0 : error.response.status;
				 if (code == 500) {
					 this.$alertify.error("Printer API error");
					 console.log(error.response.statusText);
				 } else if (error) {
					 this.$alertify.error("Printer not connected")
				 }
			 })
			 this.isLoadingSearch = false;
	 },
	}
}



// WEBPACK FOOTER //
// ./src/views/components/BinSticker/ReprintBins/ReprintBins.js